import { Location } from '@angular/common';
import { computed, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Meta } from '@df/core/meta/meta';

@Injectable({
    providedIn: 'root'
})
export class IfCheckoutProcessService {
    protected meta = inject(Meta);
    protected router = inject(Router);
    protected path = signal<string>('');

    hasView = computed(() => {
        return isCheckoutUrl(this.path());
    });

    constructor() {
        this.path.set(inject(Location).path());

        this.meta.routerEvents.pipe(takeUntilDestroyed()).subscribe(routerEvent => {
            if (routerEvent instanceof NavigationEnd) {
                this.path.set(this.router.url);
            }
        });
    }
}

export function isCheckoutUrl(path: string): boolean {
    return !!(path.match(/^\/checkout/) && !path.match(/^\/checkout\/success/));
}
